import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrain = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M12.75 11.76c1.25 0 2-1 2-2.12 0-.63-.25-1.38-1-1.88m1.04 1.95a2.87 2.87 0 0 0 2.529-.7m-3.099 2.12c.33.41.53.93.53 1.5 0 .68-.5 1.38-1 1.63m-1-9.5c0 1.25-.75 1.75-2 1.75m-3.5 1.74c-1.25 0-2 1-2 2.12 0 .63.25 1.38 1 1.88M5.21 10.3a2.87 2.87 0 0 0-2.529.7M5.78 8.88c-.33-.41-.53-.93-.53-1.5 0-.68.5-1.38 1-1.63m1 9.5c0-1.25.75-1.75 2-1.75M10 4v12m0-11.87a2.38 2.38 0 0 1 2.38-2.38c1.32 0 2.34 1.03 2.37 2.32.18-.04.5-.07.63-.07 1.59 0 2.87 1.29 2.87 2.88 0 .84-.35 1.59-.92 2.12.56.43.92 1.12.92 1.88 0 .88-.47 1.65-1.18 2.06.12.28.19.61.19.94a2.38 2.38 0 0 1-2.38 2.38h-.15a2.361 2.361 0 0 1-2.35 1.99A2.37 2.37 0 0 1 10 15.88a2.37 2.37 0 0 1-2.38 2.37c-1.32 0-2.34-1.02-2.37-2.31-.18.04-.5.07-.63.07-1.59 0-2.87-1.29-2.87-2.88 0-.84.35-1.59.92-2.12-.56-.43-.92-1.12-.92-1.88 0-.88.47-1.65 1.18-2.06-.12-.28-.19-.61-.19-.94a2.38 2.38 0 0 1 2.38-2.38h.15c.18-1.14 1.16-2 2.35-2A2.38 2.38 0 0 1 10 4.13Z"
	})]
});
const ForwardRef = forwardRef(SvgBrain);
export { ForwardRef as ReactComponent };
